export default __webpack_public_path__ + "static/media/Logo_Assembly_Employee_Recognition_3x.82f2ed3b.webp";